import { render, staticRenderFns } from "./AdminPasswordNew.vue?vue&type=template&id=17fc3e40&"
import script from "./AdminPasswordNew.vue?vue&type=script&lang=js&"
export * from "./AdminPasswordNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports